import block from 'bem-cn-lite';
import {FC, useState} from 'react';
import {Button, Checkbox, Modal, Text} from '@gravity-ui/uikit';
import {useMediaQuery} from 'react-responsive';
import {hideLateBannerForever, markLateBannerShownThisSession} from '@utils';
import LateDeliveryImage from '@assets/bannerLate/late-delivery-image.png';
import LateDeliveryImageMob from '@assets/bannerLate/late-delivery-image-mob.png';

import './ModalBannerLate.scss';

const b = block('modal-banner-late');

interface ModalBannerLateProps {
    visibility: boolean;
    stateModal: (value: boolean) => void;
}

export const ModalBannerLate: FC<ModalBannerLateProps> = ({visibility, stateModal}) => {
    const isSmallScreen = useMediaQuery({query: '(max-width: 1150px)'});
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const onCheckboxChange = (e: any, payload?: any) => {
        const next = payload?.checked ?? e?.target?.checked ?? false;

        setDontShowAgain(Boolean(next));
    };

    const onOk = () => {
        markLateBannerShownThisSession();

        if (dontShowAgain) {
            hideLateBannerForever();
        }

        stateModal(false);
    };

    return (
        <Modal open={visibility} className={b()}>
            <div className={b('container')}>
                <div className={b('image-container')}>
                    <img
                        src={isSmallScreen ? LateDeliveryImageMob : LateDeliveryImage}
                        className={b('image')}
                        alt="Задержки поставок"
                    />
                </div>

                <div className={b('content')}>
                    <div className={b('header')}>
                        <Text variant={isSmallScreen ? 'header-1' : 'display-2'}>
                            Возможны задержки поставок
                        </Text>
                    </div>

                    <div className={b('text-container')}>
                        <Text variant="body-2">Уважаемые покупатели!</Text>
                        <Text variant="body-2">
                            В связи с перебоями в поставках топлива у части перевозчиков и
                            поставщиков могут возникать задержки при отгрузке и доставке товара.
                        </Text>
                        <Text variant="body-2">
                            Просим учитывать, что по отдельным заказам возможны изменения сроков
                            доставки.
                        </Text>
                    </div>

                    <div className={b('actions')}>
                        <Checkbox size="m" checked={dontShowAgain} onChange={onCheckboxChange}>
                            Больше не показывать
                        </Checkbox>
                        <Button view="action" size="l" onClick={onOk}>
                            Ок, принято
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
